/**
 * 레퍼런스(api): https://github.kakaocorp.com/kakaopage/api/blob/c7b2307cf7f9761b8db7501e31c75d383a2f43a4/api/src/main/java/com/kakaopage/api/model/GotchaMainResponse.java#L35
 */
export enum RouletteTypeVo {
  Standalone = 'STANDALONE',
  CashSponsor = 'CASH_SPONSOR',
}
